module.exports = __webpack_public_path__ + "img/15.879c625d.jpg";